export default "__VITE_ASSET__DqSDlQ5F__"